export const APPLE_PAY_LABELS = {
    SHIPPING: 'Shipping',
    SHIPPING_DISCOUNT: 'Shipping discount',
    TAX: 'Tax',
    DISCOUNT: 'Discount',
    TOTAL: 'Total',
    LOADING: 'Loading',
    COPAY: 'Co-pay',
};

export const APPLE_PAY_DEFAULT_SHIPPING_OPTIONS = [
    {
        price: '0',
        code: 'loading',
        title: 'Options are loading',
        description: 'or address field is not filled',
        selected: true,
    },
];
